import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export enum Targets {
    USER = 'USER',
};

export enum Entities {
    CLEANING = 'CLEANING',
};

@Injectable({
    providedIn: 'root',
})
export class ReviewsService {

  constructor(
		public apiService: ApiService,
	) {
	}

  createReview(params: {}, token: string) {

		var body: any;

		body = params;

		return this.apiService.post('/reviews/create', body, token).pipe(response => response);

  }

  getReview( id: any, token: string ) {

		var body: any;

		body = {id: id.toString()};

		return this.apiService.get('/reviews/read', body, token).pipe(response => response);

  }

  updateReview(params: {}, token: string) {

		var body: any;

		body = params;

		return this.apiService.post('/reviews/update', body, token).pipe(response => response);

  }

  deleteReview( id: any, token: string ) {

		var body: any;

		body = {id: id.toString()};

		return this.apiService.post('/reviews/delete', body, token).pipe(response => response);

  }

	getReviews( target_type: string, target_id: any, page: number, token: string ) {

		var body: any;

		body = {target_type: target_type, target_id: target_id.toString()};

		return this.apiService.get('/reviews/list?page=' + page, body, token).pipe(response => response);

  }

	getRatings( target_type: string, target_id: any, token: string ) {

		var body: any;

		body = {target_type: target_type, target_id: target_id.toString()};

		return this.apiService.get('/reviews/ratings', body, token).pipe(response => response);

  }

	getReviewsByCompany( id: any, page: number, token: string ) {

		var body: any;

		body = {id: id.toString()};

		return this.apiService.get('/reviews/listByCompany?page=' + page, body, token).pipe(response => response);

  }

	getRatingsByCompany( id: any, token: string ) {

		var body: any;

		body = {id: id.toString()};

		return this.apiService.get('/reviews/ratingsByCompany', body, token).pipe(response => response);

  }

}